import {Box, Center, Skeleton, SkeletonText} from '@chakra-ui/react'
import React from 'react'

const ProductUspSkeleton = () => (
    <Box>
        <Center>
            <SkeletonText
                skeletonHeight={{base: 6, lg: 7}}
                noOfLines={{base: 2, lg: 1}}
                width={{base: '100%', lg: '500px'}}
                mb={{base: 4, lg: 8}}
            />
        </Center>
        <SkeletonText skeletonHeight={4} noOfLines={{base: 4, lg: 2}} mb={{base: 8, lg: 6}} />
        <Center>
            <Skeleton height={4} width={'100px'} />
        </Center>
    </Box>
)

export default ProductUspSkeleton
